'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var _components = require('components');

var _ImportRecipientsCSVButton = require('components/ImportRecipientsCSVButton/ImportRecipientsCSVButton');

var _ImportRecipientsCSVButton2 = _interopRequireDefault(_ImportRecipientsCSVButton);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ContactsImportButton.scss');

var ContactsImportButton = (_dec = (0, _reactRedux.connect)(null, { addContacts: _contacts.addContacts }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ContactsImportButton, _Component);

  function ContactsImportButton() {
    (0, _classCallCheck3.default)(this, ContactsImportButton);
    return (0, _possibleConstructorReturn3.default)(this, (ContactsImportButton.__proto__ || (0, _getPrototypeOf2.default)(ContactsImportButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactsImportButton, [{
    key: 'onImportRecipients',
    value: function onImportRecipients(_ref) {
      var data = _ref.data;
      var _props = this.props,
          onImport = _props.onImport,
          groupId = _props.groupId;

      this.props.addContacts(groupId, data);
      onImport(groupId, data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          groupId = _props2.groupId,
          hintBefore = _props2.hintBefore;

      var importContactParams = { queryParams: { groupId: groupId }, endpoint: '/api/contacts_wa/addContactsCSV' };

      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)(styles.container, (0, _defineProperty3.default)({}, styles.reverse, hintBefore)) },
        _react2.default.createElement(_ImportRecipientsCSVButton2.default, {
          uploaderParams: importContactParams,
          onImport: this.onImportRecipients
        }),
        _react2.default.createElement(_components.CsvHint, { className: styles.hint })
      );
    }
  }]);
  return ContactsImportButton;
}(_react.Component), _class3.propTypes = {
  addContacts: _propTypes2.default.func,
  groupId: _propTypes2.default.number,
  hintBefore: _propTypes2.default.bool,
  onImport: _propTypes2.default.func
}, _class3.defaultProps = {
  groupId: 0,
  onImport: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onImportRecipients', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onImportRecipients'), _class2.prototype)), _class2)) || _class);
exports.default = ContactsImportButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/ContactsImportButton.js
// module id = 1973
// module chunks = 1